module.exports = __webpack_public_path__ + "img/right_six.8b5a0517.svg";